import { action, computed, makeObservable, observable } from "mobx";

export interface IInjectedDOM<T> {
  host: HTMLElement;
  Component: React.FC<T>;
  props?: T;
}

class DOMInjectorImpl {
  items = new Set<IInjectedDOM<any>>();
  private nameSpaces = new Map<string, IInjectedDOM<any>[]>();
  constructor() {
    makeObservable(this, {
      items: observable.shallow,
      injectToDOM: action,
      detachByNamespace: action,
      injectedElements: computed,
    });
  }

  injectToDOM<T>(item: IInjectedDOM<T> & { namespace: string }) {
    const namespaceItems = this.nameSpaces.get(item.namespace) ?? [];
    namespaceItems.push(item);
    this.nameSpaces.set(item.namespace, namespaceItems);
    this.items.add(item);
    return item;
  }

  detachFromDOM<T>(item: IInjectedDOM<T>) {
    this.items.delete(item);
  }

  detachByNamespace(spaces: string[] | string) {
    // favor for-of over forEach to be inside mobx transaction
    const namespaces = Array.isArray(spaces) ? spaces : [spaces];
    for (const namespace of namespaces) {
      const items = this.nameSpaces.get(namespace) ?? [];
      for (const item of items) {
        this.detachFromDOM(item);
      }
      this.nameSpaces.delete(namespace);
    }
  }

  get injectedElements() {
    return Array.from(this.items).flat();
  }
}

export const DOMInjector = new DOMInjectorImpl();
